import IApiUserData from 'core/models/api-user-data'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type GlobalFiltersState = {
  storeId: number | null
  syncWithUserPreferences: (user: IApiUserData) => void
  setStoreId: (storeId: number | null) => void
}

const MY_GAME_FILTERS_STORAGE_KEY = 'mg-global-filters'

const DEFAULT_FILTERS_STATE = {
  storeId: null
}

export const useGlobalFiltersStore = create<GlobalFiltersState>()(
  persist(
    set => ({
      ...DEFAULT_FILTERS_STATE,
      syncWithUserPreferences: user =>
        set(state => ({
          storeId: state.storeId ?? user?.preferences?.default_filters?.store_id ?? null
        })),
      // Reset teamId on store change
      setStoreId: storeId => set({ storeId })
    }),
    {
      name: MY_GAME_FILTERS_STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
      partialize: state => ({
        storeId: state.storeId
      })
    }
  )
)

export const resetGlobalFiltersStore = () => {
  useGlobalFiltersStore.setState(DEFAULT_FILTERS_STATE)
}
